import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/dashboard/[id]/dearest/book/page";

export const Route = createFileRoute(
  "/clients/$clientId/dashboard/dearest/book/",
)({
  component: Page,
});
